import { architectureDisplayName } from '@/components/jobArchitecture/helpers';

const UNCATEGORIZED_KEY = '__uncategorized__';

const sortByName = (a, b) => (
  architectureDisplayName(a?.name).localeCompare(architectureDisplayName(b?.name))
);

/**
 * Builds the job family dropdown list: group names as labels, then families under each group.
 */
export const buildJobFamilySelectItems = ({
  jobFamilies = [],
  jobFamilyGroups = [],
} = {}) => {
  const activeFamilies = jobFamilies.filter((family) => family?.ulid && family.is_active !== false);
  const activeGroups = jobFamilyGroups.filter((group) => group?.ulid && group.is_active !== false);

  const groupByUlid = new Map(activeGroups.map((group) => [group.ulid, group]));
  const knownGroupUlids = new Set(activeGroups.map((group) => group.ulid));

  const familiesByGroup = new Map();

  activeFamilies.forEach((family) => {
    const groupUlid = family.group_ulid && knownGroupUlids.has(family.group_ulid)
      ? family.group_ulid
      : UNCATEGORIZED_KEY;

    if (!familiesByGroup.has(groupUlid)) {
      familiesByGroup.set(groupUlid, []);
    }

    familiesByGroup.get(groupUlid).push(family);
  });

  const sortedGroupUlids = [
    ...activeGroups.sort(sortByName).map((group) => group.ulid),
    ...(familiesByGroup.has(UNCATEGORIZED_KEY) ? [UNCATEGORIZED_KEY] : []),
  ];

  const items = [];

  sortedGroupUlids.forEach((groupUlid) => {
    const families = (familiesByGroup.get(groupUlid) || []).sort(sortByName);

    if (!families.length) return;

    const group = groupUlid === UNCATEGORIZED_KEY
      ? { name: 'Uncategorized' }
      : groupByUlid.get(groupUlid);

    items.push({
      isGroupHeader: true,
      title: architectureDisplayName(group?.name),
    });

    families.forEach((family) => {
      items.push({
        isGroupHeader: false,
        title: family.name,
        value: family.ulid,
      });
    });
  });

  return items;
};

export const getJobFamilyUlid = (family) => family?.ulid ?? family?.id ?? null;

export const findJobFamilyByUlid = (jobFamilies, ulid) => (
  (jobFamilies || []).find((family) => getJobFamilyUlid(family) === ulid) ?? null
);
